/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;

  path {
    fill: none;
  }
`
export default class AttendanceCheckIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="28.239" height="19.619" viewBox="0 0 28.239 19.619" css={Color} className="attendance-check-ico">
          <path id="패스_42576" data-name="패스 42576" d="M707.439,19351.035l9.253,10,14.747-16"
                transform="translate(-705.319 -19342.916)" fill="none" stroke="#fff" strokeLinecap="round"
                strokeLinejoin="round" strokeWidth="3"/>
        </svg>
      </Fragment>
    )
  }
}
